import { isApiSliceSaveSuccess } from './isApiSliceSaveSuccess';
var DEFAULT_TIMEOUT_MS = 60000;
/**
 * Subscribes to the Redux store, runs `trigger()` (e.g. saveConfig), and resolves when the api slice
 * for `sliceKey` leaves `requesting` after a request was seen. Uses synchronous store subscription
 * so the result is read before React effects (e.g. clearSaveData) can reset the slice.
 */
export function waitForApiSliceTerminal(store, sliceKey, trigger, timeoutMs) {
    if (timeoutMs === void 0) { timeoutMs = DEFAULT_TIMEOUT_MS; }
    return new Promise(function (resolve) {
        var sawRequesting = false;
        var finished = false;
        var timeoutId;
        var unsubscribe = function () { };
        var finish = function (ok) {
            if (finished)
                return;
            finished = true;
            clearTimeout(timeoutId);
            unsubscribe();
            resolve(ok);
        };
        unsubscribe = store.subscribe(function () {
            var s = store.getState().api[sliceKey];
            if (s === null || s === void 0 ? void 0 : s.requesting)
                sawRequesting = true;
            if (!sawRequesting)
                return;
            if (!s) {
                finish(false);
                return;
            }
            if (s.requesting)
                return;
            finish(isApiSliceSaveSuccess(store.getState(), sliceKey));
        });
        timeoutId = setTimeout(function () { return finish(false); }, timeoutMs);
        try {
            trigger();
        }
        catch (_a) {
            finish(false);
        }
    });
}
